import React, { useEffect } from "react";
import { useFormikContext } from "formik";
import Text from "components/atoms/Text";
import CheckboxField from "components/molecules/CheckboxField";
import { Space } from "antd";
import { networkOptions } from "../utils/options";
import TableField from "components/molecules/TableField";
import DateField from "components/molecules/DateField";
import TableMenu from "components/molecules/TableMenu";
import { autoFillOutOfNetworkCoverage } from "../utils/table";
import { useLocation } from "react-router-dom";
import { separateOrCombinedOptions, yesOrNoOptions } from "../utils/options";

const columns = [
  {
    title: "",
    dataIndex: "idx",
    width: 22.5,
    editable: false,
    fixed: "left",
  },
  {
    title: "",
    dataIndex: "label",
    width: 100,
    editable: true,
    disabled: true,
    inputType: "text",
    shouldCellUpdate: () => false,
  },
  {
    title: "Deductible Type",
    dataIndex: "deductibleType",
    width: 80,
    editable: true,
    inputType: "select",
    dropdownMatchSelectWidth: 350,
    options: separateOrCombinedOptions,
    shouldCellUpdate: () => false,
  },
  {
    title: "Individual Deductible",
    dataIndex: "individualDeductible",
    width: 100,
    editable: true,
    inputType: "currency",
    shouldCellUpdate: (record, prevRecord) => {
      return record.deductibleType !== prevRecord.deductibleType;
    },
  },
  {
    title: "Family Deductible",
    dataIndex: "familyDeductible",
    width: 100,
    editable: true,
    inputType: "currency",
    shouldCellUpdate: (record, prevRecord) => {
      return record.deductibleType !== prevRecord.deductibleType;
    },
  },
  {
    title: "Medical and Drug Deductibles Cross-Accumulate",
    dataIndex: "crossAccumulate",
    width: 80,
    editable: true,
    inputType: "select",
    dropdownMatchSelectWidth: 350,
    options: yesOrNoOptions,
    shouldCellUpdate: (record, prevRecord) => {
      return record.deductibleType !== prevRecord.deductibleType;
    },
  },
  {
    title: "OOP Limit Type",
    dataIndex: "oopType",
    width: 80,
    editable: true,
    inputType: "select",
    dropdownMatchSelectWidth: 350,
    options: separateOrCombinedOptions,
    shouldCellUpdate: () => false,
  },
  {
    title: "Individual OOP Limit",
    dataIndex: "individualOOPMax",
    width: 100,
    editable: true,
    inputType: "currency",
    shouldCellUpdate: (record, prevRecord) => {
      return record.deductibleType !== prevRecord.deductibleType;
    },
  },
  {
    title: "Family OOP Limit",
    dataIndex: "familyOOPMax",
    width: 100,
    editable: true,
    inputType: "currency",
    shouldCellUpdate: (record, prevRecord) => {
      return record.deductibleType !== prevRecord.deductibleType;
    },
  },
  {
    title: "",
    key: "operation",
    fixed: "right",
    width: 48,
    render: (_, record) => record.idx > 1 && <TableMenu record={record} step={4} />,
  },
].map((col) => {
  return {
    ...col,
    onCell: (_, idx) => ({
      index: idx,
      editable: col.editable,
      dataIndex: col.dataIndex,
      title: col.title,
      inputType: col.inputType,
      options: col.options,
      dropdownMatchSelectWidth: col.dropdownMatchSelectWidth,
      disabled: col.disabled || false,
      isMultiSelect: col.isMultiSelect || false,
      emptyValue: col.emptyValue,
    }),
  };
});

const Step = () => {
  const { state } = useLocation();
  const { values, setErrors, setTouched, setFieldValue } = useFormikContext();
  const { table, pharmacyManagersTable } = values;

  useEffect(() => {
    document.getElementById("form-content").scrollTo({ top: 0, behavior: "smooth" });
    setErrors({});
    setTouched({}, false);
  }, []);

  return (
    <>
      {/* <Text sectionTitle>Pharmacy Benefit Managers</Text> */}
      <Space direction="vertical" size="middle" style={{ display: "flex" }}>
        <TableField name="table" columns={columns} dataSource={table} tableLayout="fixed" />
      </Space>
    </>
  );
};

export default Step;
